export const REQUEST_STATUS = Object.freeze({
  INACTIVE:'isInactive',
  PENDING: 'isPending',
  SUCCESSFUL: 'isSuccessful',
  FAILED: 'isFailed'
});